import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import IncidentReportForm from "./IncidentReportComponents/IncidentReportForm";

import { useAddIncidentReportMutation } from "store/services/incidentReportApi";

const IncidentReportCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Incident Report", path: "/app/crm/incident-report/list" },
    { title: "New Incident" },
  ];

  // RTK query hook for adding a real-time incident entry
  const [addIncidentReport, { isLoading }] = useAddIncidentReportMutation();

  const handleCreateIncidentReport = async (data) => {
    try {
      const { _id } = await addIncidentReport(data).unwrap();
      toast.success("Incident Report successfully created!");
      navigate(`/app/crm/incident-report/${_id}/detail`); 
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Incident Report!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <IncidentReportForm
          isBusy={isLoading}
          onSubmit={handleCreateIncidentReport}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default IncidentReportCreateScreen;
